<template>
    <TemplatesNeighborhoodsPage />
</template>
